import { CognitoUser } from '../interfaces/cognitoUser';

export function getUserGroups(user?: CognitoUser | null): string[] {
    return user?.signInUserSession.accessToken.payload['cognito:groups'] ?? [];
}
